import { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebaseClient';

const BACKEND = 'https://3amenu.com/api';

export default function Register() {
  const [adim, setAdim] = useState(1); // 1: form, 2: plan seç, 3: başarı
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [sifreTekrar, setSifreTekrar] = useState('');
  const [kafeAdi, setKafeAdi] = useState('');
  const [telefon, setTelefon] = useState('');
  const [secilenPlan, setSecilenPlan] = useState('standart');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [sifreGoster, setSifreGoster] = useState(false);

  const planlar = [
    {
      id: 'standart',
      ad: 'Standart',
      fiyat: '990',
      desc: 'Dijital menüye geçmek isteyen kafeler için',
      ozellikler: ['QR Menü & QR Kod Üretici', 'Sınırsız Kategori & Ürün', 'Dijital Sipariş Sistemi', 'Garson Çağırma & Hesap İsteme', 'Ciro Raporları', 'TR / EN Dil Desteği'],
    },
    {
      id: 'pro',
      ad: 'Pro',
      fiyat: '1.890',
      desc: 'Deneyimi zirveye taşımak isteyenler için',
      ozellikler: ['Standart\'taki her şey +', 'AI Destekli Menü', 'Sadakat Kartı Sistemi', 'Kampanya & İndirim Yönetimi', 'AR / RU Dil Desteği', 'Öncelikli Destek'],
      popular: true,
    },
  ];

  const kayitOl = async () => {
    setHata('');
    if (!email.trim() || !sifre.trim() || !kafeAdi.trim()) { setHata('Tüm alanları doldurun!'); return; }
    if (sifre !== sifreTekrar) { setHata('Şifreler eşleşmiyor!'); return; }
    if (sifre.length < 6) { setHata('Şifre en az 6 karakter olmalı!'); return; }

    setYukleniyor(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, sifre);
      const uid = userCredential.user.uid;

      // Backend'e plan ve kafe adı kaydet
      await fetch(`${BACKEND}/admin/kullanici-plan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, plan: secilenPlan }),
      });

      // Kafeler koleksiyonuna temel bilgileri kaydet
      await fetch(`${BACKEND}/menu/kafe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: uid, slug: uid.slice(0, 8), ad: kafeAdi, tagline: '' }),
      });

      // PayTR token al ve ödemeye yönlendir
const odemeRes = await fetch(`${BACKEND}/odeme/baslat`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ uid, email, plan: secilenPlan }),
}).then(r => r.json());

if (odemeRes.success && odemeRes.token) {
  window.location.href = `https://www.paytr.com/odeme/guvenli/${odemeRes.token}`;
} else {
  setAdim(3); // ödeme başaramazsa başarı sayfasına git
}
} catch (err) {
      if (err.code === 'auth/email-already-in-use') setHata('Bu email zaten kayıtlı!');
      else if (err.code === 'auth/invalid-email') setHata('Geçersiz email adresi!');
      else setHata('Bir hata oluştu, tekrar deneyin.');
      console.error(err);
    }
    setYukleniyor(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#080808', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'Syne', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input { background: rgba(255,255,255,0.06) !important; border: 1px solid #222 !important; border-radius: 12px !important; padding: 14px 16px !important; color: white !important; font-size: 14px !important; width: 100% !important; outline: none !important; font-family: 'Syne', sans-serif !important; transition: border-color 0.2s !important; }
        input:focus { border-color: #f97316 !important; }
        input::placeholder { color: #444 !important; }
        .plan-card { border: 2px solid #1a1a1a; border-radius: 16px; padding: 24px; cursor: pointer; transition: all 0.2s; background: #0d0d0d; }
        .plan-card.selected { border-color: #f97316; background: rgba(249,115,22,0.06); }
        .plan-card:hover { border-color: #333; }
        .btn { background: #f97316; color: white; border: none; border-radius: 12px; padding: 16px; font-size: 15px; font-weight: 700; cursor: pointer; width: 100%; font-family: 'Syne', sans-serif; transition: all 0.2s; }
        .btn:hover { background: #ea6d15; transform: translateY(-1px); }
        .btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
        .btn-ghost { background: transparent; color: #555; border: 1px solid #222; border-radius: 12px; padding: 16px; font-size: 15px; font-weight: 600; cursor: pointer; width: 100%; font-family: 'Syne', sans-serif; transition: all 0.2s; text-align: center; text-decoration: none; display: block; }
        .btn-ghost:hover { border-color: #444; color: #888; }
      `}</style>

      <div style={{ width: '100%', maxWidth: 480 }}>
        {/* Logo */}
        <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, marginBottom: 40 }}>
          <span style={{ fontSize: 28, fontWeight: 800, color: '#f97316' }}>3A</span>
          <span style={{ fontSize: 28, fontWeight: 800, color: '#fff' }}>Menu</span>
        </a>

        {/* Adım göstergesi */}
        {adim < 3 && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 36 }}>
            {[1, 2].map(s => (
              <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, background: adim >= s ? '#f97316' : '#1a1a1a', color: adim >= s ? 'white' : '#444', transition: 'all 0.3s' }}>{s}</div>
                {s < 2 && <div style={{ width: 40, height: 1, background: adim > s ? '#f97316' : '#1a1a1a', transition: 'all 0.3s' }} />}
              </div>
            ))}
          </div>
        )}

        {/* Adım 1: Bilgiler */}
        {adim === 1 && (
          <div style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 20, padding: 32 }}>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: 'white', marginBottom: 8 }}>Hesap Oluştur</h1>
            <p style={{ fontSize: 14, color: '#555', marginBottom: 28 }}>Dakikalar içinde dijital menünüz hazır.</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginBottom: 6 }}>Kafe Adı</label>
                <input value={kafeAdi} onChange={e => setKafeAdi(e.target.value)} placeholder="Örn: Kahve Dünyası" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginBottom: 6 }}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ornek@email.com" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginBottom: 6 }}>Telefon (opsiyonel)</label>
                <input type="tel" value={telefon} onChange={e => setTelefon(e.target.value)} placeholder="05XX XXX XX XX" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginBottom: 6 }}>Şifre</label>
                <div style={{ position: 'relative' }}>
                  <input type={sifreGoster ? 'text' : 'password'} value={sifre} onChange={e => setSifre(e.target.value)} placeholder="En az 6 karakter" style={{ paddingRight: '44px !important' }} />
                  <button onClick={() => setSifreGoster(!sifreGoster)} style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#444' }}>{sifreGoster ? '🙈' : '👁️'}</button>
                </div>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginBottom: 6 }}>Şifre Tekrar</label>
                <input type="password" value={sifreTekrar} onChange={e => setSifreTekrar(e.target.value)} placeholder="Şifrenizi tekrar girin" />
              </div>
            </div>

            {hata && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 10, padding: '12px 16px', marginTop: 16, fontSize: 13, color: '#ef4444' }}>⚠️ {hata}</div>}

            <button className="btn" onClick={() => {
              setHata('');
              if (!email.trim() || !sifre.trim() || !kafeAdi.trim()) { setHata('Tüm alanları doldurun!'); return; }
              if (sifre !== sifreTekrar) { setHata('Şifreler eşleşmiyor!'); return; }
              if (sifre.length < 6) { setHata('Şifre en az 6 karakter olmalı!'); return; }
              setAdim(2);
            }} style={{ marginTop: 24 }}>
              Devam Et →
            </button>

            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#444' }}>
              Zaten hesabın var mı? <a href="/login" style={{ color: '#f97316', textDecoration: 'none' }}>Giriş Yap</a>
            </p>
          </div>
        )}

        {/* Adım 2: Plan seç */}
        {adim === 2 && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <h1 style={{ fontSize: 24, fontWeight: 800, color: 'white', marginBottom: 8 }}>Planınızı Seçin</h1>
              <p style={{ fontSize: 14, color: '#555' }}>İstediğiniz zaman plan değiştirebilirsiniz.</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 20 }}>
              {planlar.map(plan => (
                <div key={plan.id} className={`plan-card ${secilenPlan === plan.id ? 'selected' : ''}`} onClick={() => setSecilenPlan(plan.id)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: 15, fontWeight: 700, color: secilenPlan === plan.id ? '#f97316' : '#aaa' }}>{plan.ad}</span>
                        {plan.popular && <span style={{ fontSize: 10, background: 'rgba(249,115,22,0.15)', color: '#f97316', border: '1px solid rgba(249,115,22,0.3)', borderRadius: 100, padding: '2px 8px', fontWeight: 700 }}>POPÜLER</span>}
                      </div>
                      <p style={{ fontSize: 12, color: '#444', marginTop: 2 }}>{plan.desc}</p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <span style={{ fontSize: 22, fontWeight: 800, color: 'white' }}>₺{plan.fiyat}</span>
                      <span style={{ fontSize: 11, color: '#444' }}>/ay</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {plan.ozellikler.map((o, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#666' }}>
                        <span style={{ color: '#f97316', fontSize: 11 }}>✓</span>{o}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${secilenPlan === plan.id ? '#f97316' : '#333'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {secilenPlan === plan.id && <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#f97316' }} />}
                    </div>
                    <span style={{ fontSize: 12, color: secilenPlan === plan.id ? '#f97316' : '#444' }}>
                      {secilenPlan === plan.id ? 'Seçildi' : 'Seç'}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {hata && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: '#ef4444' }}>⚠️ {hata}</div>}

            <button className="btn" onClick={kayitOl} disabled={yukleniyor}>
              {yukleniyor ? '⏳ Hesap oluşturuluyor...' : `${secilenPlan === 'pro' ? '🚀 Pro' : '⭐ Standart'} ile Başla →`}
            </button>

            <button className="btn-ghost" onClick={() => setAdim(1)} style={{ marginTop: 10 }}>← Geri</button>

            <p style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: '#333', lineHeight: 1.6 }}>
              Kayıt olarak <a href="#" style={{ color: '#444' }}>Kullanım Koşulları</a>'nı kabul etmiş olursunuz.<br />
              Ödeme 3amenu.com üzerinden WhatsApp ile alınmaktadır.
            </p>
          </div>
        )}

        {/* Adım 3: Başarı */}
        {adim === 3 && (
          <div style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 20, padding: 40, textAlign: 'center' }}>
            <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(34,197,94,0.1)', border: '2px solid rgba(34,197,94,0.3)', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🎉</div>
            <h2 style={{ fontSize: 24, fontWeight: 800, color: 'white', marginBottom: 12 }}>Hesabınız Oluşturuldu!</h2>
            <p style={{ fontSize: 14, color: '#555', marginBottom: 8, lineHeight: 1.7 }}>
              <strong style={{ color: '#aaa' }}>{kafeAdi}</strong> için hesabınız başarıyla oluşturuldu.
            </p>
            <p style={{ fontSize: 13, color: '#444', marginBottom: 32, lineHeight: 1.7 }}>
              Ödeme ve aktivasyon için WhatsApp'tan bize ulaşın. Sistem <strong style={{ color: '#f97316' }}>24 saat</strong> içinde aktif edilecek.
            </p>

            <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 14, padding: 20, marginBottom: 24, textAlign: 'left' }}>
              <p style={{ fontSize: 12, color: '#555', marginBottom: 12, fontWeight: 600 }}>Seçilen Plan:</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 15, fontWeight: 700, color: '#f97316' }}>{secilenPlan === 'pro' ? '🚀 Pro' : '⭐ Standart'}</span>
                <span style={{ fontSize: 18, fontWeight: 800, color: 'white' }}>₺{secilenPlan === 'pro' ? '1.890' : '990'}/ay</span>
              </div>
            </div>

            <a href={`https://wa.me/905324490381?text=Merhaba%2C%203AMenu%20hesab%C4%B1m%C4%B1%20aktif%20etmek%20istiyorum.%20Email%3A%20${encodeURIComponent(email)}`}
              target="_blank" rel="noreferrer" className="btn" style={{ display: 'block', textDecoration: 'none', marginBottom: 12 }}>
              💬 WhatsApp'tan Ödeme Yap
            </a>
            <a href="/login" className="btn-ghost">Giriş Yap →</a>
          </div>
        )}
      </div>
    </div>
  );
}